import React, { useEffect, useState } from "react";
import { api } from "../../../lib/api";
import { ButtonTaps, DailyChart, SERIES } from "./StatsCharts";

const DEVICES = [["android", "Android"], ["ios", "iPhone"], ["desktop", "Computer"]];
const NOTES = { tap: "on all Get the app buttons", install: "first time the app is opened", apk_download: "Ishukart.apk downloads" };
const fmt = (d) => new Date(`${d}T00:00:00`).toLocaleDateString("en-IN", { day: "numeric", month: "short" });

const Tile = ({ kind, label, color, s }) => (
  <div className="rounded-xl bg-slate-50 p-4" data-testid={`mobile-stats-${kind}`}>
    <p className="text-xs font-semibold uppercase tracking-wider" style={{ color }}>{label}</p>
    <p className="mt-1 font-display text-3xl font-semibold text-slate-900" data-testid={`mobile-stats-${kind}-total`}>{s.totals[kind]}</p>
    <p className="text-xs text-slate-500">{NOTES[kind]}</p>
    <div className="mt-3 flex flex-wrap gap-1.5">
      {DEVICES.map(([d, name]) => (
        <span key={d} className="px-2 py-0.5 rounded-full bg-white ring-1 ring-slate-200 text-[11px] text-slate-600" data-testid={`mobile-stats-${kind}-${d}`}>
          {name} <b className="font-mono text-slate-900">{s.by_device[kind][d]}</b>
        </span>
      ))}
    </div>
  </div>
);

export const DownloadStats = () => {
  const [s, setS] = useState(null);
  useEffect(() => { api.adminMobileStats().then(setS).catch(() => {}); }, []);
  if (!s) return <div className="h-40 rounded-2xl border border-slate-200 bg-white animate-pulse" data-testid="mobile-stats-loading" />;
  return (
    <section className="rounded-2xl border border-slate-200 bg-white p-5 sm:p-6 space-y-6" data-testid="mobile-stats">
      <div>
        <h2 className="font-display text-lg font-semibold text-slate-900">Downloads this week</h2>
        <p className="text-sm text-slate-500" data-testid="mobile-stats-range">Last 7 days · {fmt(s.from)} – {fmt(s.to)}</p>
      </div>
      <div className="grid md:grid-cols-3 gap-3">{SERIES.map(([k, label, color]) => <Tile key={k} kind={k} label={label} color={color} s={s} />)}</div>
      <div className="grid lg:grid-cols-[1.6fr_1fr] gap-8">
        <DailyChart daily={s.daily} />
        <div>
          <p className="mb-3 text-xs font-semibold uppercase tracking-wider text-slate-500">Taps by button</p>
          <ButtonTaps rows={s.by_source} />
        </div>
      </div>
    </section>
  );
};

export default DownloadStats;
